export default "__VITE_ASSET__Bwat_YvM__"